import React, { useEffect, useState } from "react";
import Countdown from "react-countdown";
import "./App.css";

const App = () => {
  const [launchDate, setLaunchDate] = useState(null);

  useEffect(() => {
    // Fetch the launch date from the server
    fetch("/api/launch-date")
      .then((response) => response.json())
      .then((data) => {
        setLaunchDate(new Date(data.launchDate).getTime());
      })
      .catch((error) => console.error("Error fetching launch date:", error));
  }, []);

  // Renderer for countdown
  const renderer = ({ days, hours, minutes, seconds }) => (
    <div className="countdown-timer">
      <span>{days}d</span>
      <span>{hours}h</span>
      <span>{minutes}m</span>
      <span>{seconds}s</span>
    </div>
  );

  if (!launchDate) {
    return <div className="coming-soon-page">Loading...</div>; // Show loading state
  }

  return (
    <div className="coming-soon-page">
      <h1>Bogo Ninja</h1>
      <h2>Coming soon to a neighborhood near you!</h2>
      <Countdown date={launchDate} renderer={renderer} />
    </div>
  );
};

export default App;
